// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604280803/js/" + chunkId + "." + {"44":"7e3db1f1","225":"399da700","481":"82fa6b69","486":"37562809","770":"e074378d"}[chunkId] + ".0.2752933578783725.chunk.js";
};